// Hastegrad (militær presedens) — ÉN kilde til etikettene, jf. grunnloven §3.
//
// FLASH / IMMEDIATE / PRIORITY / ROUTINE er NATO-PRIORITETSKODEORD (ACP 121 /
// STANAG-meldingstjeneste), ikke engelsk prosa. De brukes UOVERSATT i militær
// meldingstjeneste — på samme måte som det fonetiske alfabetet (ALFA, BRAVO) og
// fagtermene grunnloven §8 eksplisitt verner (SALUTE, MEDEVAC). Et kodeord er
// verdt noe nettopp fordi det er identisk hos alle som skal forstå det; oversetter
// vi det til noe vi finner på selv, får SKADE et vokabular ingen annen avdeling
// eller alliert bruker. Det er verre enn å la ordet stå.
//
// ⚠ TIL DEN NESTE SOM VIL «RETTE DETTE TIL NORSK»: ikke gjør det.
//   1) Kodeordet skal stå i KONSEKVENTE STORE BOKSTAVER. Store bokstaver er det
//      som gjør at ordet leses som et kodeord og ikke som engelsk ord. Blandet
//      «FLASH / Immediate / Priority / Routine» var nettopp feilen dette
//      erstatter: samme sett kodeord skrevet på fire måter i samme nedtrekk.
//   2) Norsk hjelp SKAL være en klargjøring av RANGERING — «(høyest)» /
//      «(lavest)» — så en operatør som møter kodeordene første gang skjønner
//      hvilken vei skalaen går uten opplæring.
//   3) IKKE dikt opp tidsfrister («innen 30 min», «innen 6 timer»). Det er
//      doktrine, og vi HAR ikke doktrinen. Oppdiktede frister ville bli lest som
//      krav og styre handling — grunnloven §1, ærlighet over fremdrift.
//
// ÅPENT SPØRSMÅL FOR EIER: bruker Forsvaret norske prioritetsord i denne rollen?
// Får vi bekreftet at de gjør det, er dette den ENE fila som skal endres.
/** Rang: LAVERE tall = HØYERE hastegrad (samme konvensjon som QOS/RFI-sortering). */
export const PRECEDENCE_RANK = {
    flash: 0, immediate: 1, priority: 2, routine: 3,
};
/**
 * Rent kodeord i store bokstaver — brukes der plassen er trang (chip, kolonne,
 * meldingshode) og der teksten skal kunne leses som et NATO-kodeord alene.
 */
export const PRECEDENCE_CODEWORD = {
    flash: 'FLASH', immediate: 'IMMEDIATE', priority: 'PRIORITY', routine: 'ROUTINE',
};
/**
 * Etikett for nedtrekk/lister: kodeord + norsk klargjøring av rangering på
 * YTTERPUNKTENE. Bare ytterpunktene, med vilje — det er de som forteller hvilken
 * vei skalaen går. Å merke alle fire («nest høyest», «nest lavest») gjør raden
 * lengre uten å gi operatøren noe hun ikke alt kan slutte seg til.
 */
export const PRECEDENCE_LABEL = {
    flash: 'FLASH (høyest)',
    immediate: 'IMMEDIATE',
    priority: 'PRIORITY',
    routine: 'ROUTINE (lavest)',
};
/**
 * Sorter et sett hastegrader HØYEST FØRST.
 *
 * Finnes fordi zod-enumene lister verdiene lavest-først (`['routine', …,
 * 'flash']`) mens et nedtrekk skal vise det mest alvorlige øverst. Uten denne
 * måtte hver flate skrive sin egen rekkefølge-liste — som er akkurat den
 * divergensen §3 forbyr. Tar imot et undersett (ResupplyPriority har ingen
 * FLASH) og bevarer typen.
 */
export function precedenceOrder(ids) {
    return [...ids].sort((a, b) => PRECEDENCE_RANK[a] - PRECEDENCE_RANK[b]);
}
//# sourceMappingURL=precedence.js.map